import { WithStatePaginatedTable } from '@delmonicos/shared-design-system-react/src/components/with-state-paginated-table/with-state-paginated-table';
import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { TransformedPaginatedData } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/transform-api-paginated-response/transformed-paginated-data.model';
import { OnChangeFn, SortingState } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { StateEnum } from '@model/enum/state.enum';

import {
  CUSTOMER_NETWORK_LIST_COLUMN_LIST,
  CUSTOMER_NETWORK_LIST_COLUMN_ORDER,
  CUSTOMER_NETWORK_LIST_COLUMN_VISIBILITY,
} from './customer-network-list.config';

interface CustomerNetworkListViewProps {
  paginationLimit: number;
  paginationLimitList: number[];
  paginationState: StateEnum;
  paginationSorting: SortingState;
  resource?: TransformedPaginatedData<GatewayNetworkModel>;
  onPaginationLimitChange: (paginationLimitNext: number) => void;
  onPaginationPageChange: (paginationPageNext: number) => void;
  onPaginationSortingChange?: OnChangeFn<SortingState>;
}

export const CustomerNetworkListView = ({
  paginationLimit,
  paginationLimitList,
  paginationState,
  paginationSorting,
  resource,
  onPaginationLimitChange,
  onPaginationPageChange,
  onPaginationSortingChange,
}: CustomerNetworkListViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <WithStatePaginatedTable
      paginatedData={resource}
      state={paginationState}
      sorting={paginationSorting}
      columns={CUSTOMER_NETWORK_LIST_COLUMN_LIST}
      columnOrder={CUSTOMER_NETWORK_LIST_COLUMN_ORDER}
      columnVisibility={CUSTOMER_NETWORK_LIST_COLUMN_VISIBILITY}
      limit={paginationLimit}
      limitList={paginationLimitList}
      errorMessage={t('$.network-list.error')}
      onLimitChange={onPaginationLimitChange}
      onPageChange={onPaginationPageChange}
      onSortingChange={onPaginationSortingChange}
    />
  );
};
